<div [formGroup]="formService.form">
	<div class="project-name">
		<mat-form-field class="project-name__field">
			<mat-label>案件名</mat-label>
			<input matInput formControlName="projectName" />
		</mat-form-field>
	</div>
	<div class="base-manday">
		<mat-form-field class="base-manday__field">
			<mat-label>一人日あたりの単価</mat-label>
			<input
				matInput
				formControlName="basePrice"
				[matAutocomplete]="autoBasePrice"
			/>
			<mat-autocomplete
				autoActiveFirstOption
				#autoBasePrice="matAutocomplete"
			>
				<mat-option [value]="10000">10000</mat-option>
				<mat-option [value]="20000">20000</mat-option>
				<mat-option [value]="30000">30000</mat-option>
				<mat-option [value]="40000">40000</mat-option>
				<mat-option [value]="50000">50000</mat-option>
				<mat-option [value]="60000">60000</mat-option>
			</mat-autocomplete>
			<mat-error
				*ngIf="formService.form.controls.basePrice.hasError('pattern')"
			>
				半角数字で入力してください
			</mat-error>
		</mat-form-field>
		円
	</div>
	<div class="form-container">
		<table>
			<thead>
				<tr>
					<th class="th-1">No.</th>
					<th class="th-2">作業内容</th>
					<th class="th-3">工数（人日）</th>
					<th class="th-4">価格</th>
					<th class="th-5"></th>
				</tr>
			</thead>
			<tbody
				formArrayName="workDetails"
				cdkDropList
				(cdkDropListDropped)="drop($event)"
			>
				<tr
					*ngFor="
						let value of formService.workDetails.controls;
						let i = index
					"
					cdkDrag
					cdkDragLockAxis="y"
					[formGroupName]="i"
				>
					<td class="td-1">
						{{ this.i + 1 }}
					</td>
					<td class="td-2">
						<mat-form-field>
							<input matInput formControlName="title" />
						</mat-form-field>
					</td>
					<td class="td-3">
						<mat-form-field>
							<input
								matInput
								formControlName="manday"
								[matAutocomplete]="autoManDay"
							/>
							<mat-autocomplete
								autoActiveFirstOption
								#autoManDay="matAutocomplete"
							>
								<mat-option [value]="0.5">0.5</mat-option>
								<mat-option [value]="1">1</mat-option>
								<mat-option [value]="1.5">1.5</mat-option>
								<mat-option [value]="2">2</mat-option>
								<mat-option [value]="2.5">2.5</mat-option>
								<mat-option [value]="3">3</mat-option>
								<mat-option [value]="3.5">3.5</mat-option>
								<mat-option [value]="4">4</mat-option>
								<mat-option [value]="4.5">4.5</mat-option>
								<mat-option [value]="5">5</mat-option>
								<mat-option [value]="5.5">5.5</mat-option>
								<mat-option [value]="6">6</mat-option>
								<mat-option [value]="6.5">6.5</mat-option>
								<mat-option [value]="7">7</mat-option>
							</mat-autocomplete>
							<mat-error>
								半角数字で入力してください
							</mat-error>
						</mat-form-field>
					</td>
					<td class="td-4">
						<span
							>{{
								(
									formService.form.value.basePrice *
									formService.form.value.workDetails[i].manday
								).toLocaleString()
							}}
							円</span
						>
					</td>
					<td class="td-5">
						<span *ngIf="formService.displayRemoveIcon">
							<button
								(click)="formService.removeWorkDetails(i)"
								mat-icon-button
								color="warn"
							>
								<mat-icon>delete</mat-icon>
							</button>
						</span>
					</td>
				</tr>
			</tbody>
		</table>
		<button
			(click)="formService.addWorkDetails()"
			mat-raised-button
			color="primary"
		>
			<mat-icon>add</mat-icon>行を追加する
		</button>
	</div>
</div>

<div class="sum">
	<div>合計工数：{{ formService.form.value.totalManday }}人日</div>
	<div>合計金額：{{ formService.form.value.totalPrice }}円</div>
	<div>税込価格：{{ formService.form.value.totalPriceIncludeTax }}円</div>
</div>
<div class="copy">
	<button
		mat-raised-button
		color="basic"
		(click)="formService.copyToClipboard()"
	>
		<mat-icon>content_copy</mat-icon> クリップボードにコピーする
	</button>
</div>
